import React, { useState, useEffect } from "react";
import { Container, Col, Row, Form, FormGroup, Modal } from "react-bootstrap";
import "react-rangeslider/lib/index.css";
import {
  MdNavigateNext,
  MdNavigateBefore,
  MdAdd,
  MdClose,
} from "react-icons/md";
import FormValidator from "../../../../../shared/utils/FormValidator";
import { useStorage, useFunctions } from "reactfire";
import BarLoader from "react-spinners/BarLoader";
import Guidelines from "../../guidelines/Guidelines";
import randomString from "randomstring";
import AppFormCheck from "../../app-form-check/AppFormCheck";
import { AiOutlineFilePdf } from "react-icons/ai";
import { Country, TeamRole } from "../../../../../shared/constants/Constant";
import Application from "../../../../../database/models/application-form/india/Application";
import TeamMember from "../../../../../database/models/application-form/india/TeamMember";
import Slider from "react-rangeslider";
import Alert from "../../../../../shared/components/alert/Alert";

interface IState {
  isAgree: boolean;
  isAgreeError: string;
  projectName: string;
  projectNameError: string;
  problem: string;
  problemError: string;
  unique: string;
  uniqueError: string;
  stage:
    | undefined
    | "Concept"
    | "Defining the product"
    | "Building prototype"
    | "Have beta users using the product"
    | "Commercial"
    | "Looking to scale up"
    | "other";
  otherState: string;
  otherStateError: string;
  stageError: any;
  progress: string;
  progressError: string;
  pitch: any;
  pitchError: any;
  pitchLink: string;
  pitchLinkError: string;
  requiredInvensment: string;
  requiredInvensmentError: string;
  invesmentDone: string;
  invesmentDoneError: string;
  expectedTime: string;
  expectedTimeError: string;
  anyPatent: string;
  anyPatentError: string;
  whyEntreprenur: string;
  whyEntreprenurError: string;
  howLoongThinking:
    | undefined
    | "Since this mailer was received"
    | "More than a month"
    | "1 to 3 months"
    | "3 - 6 months"
    | ">6 months";
  howLoongThinkingError: string;
  strenghts: string;
  strenghtsError: string;
  anyCourse: string;
  anyCourseError: string;
  howStrong: number;
  howStrongError: string;
  admireEntreprenur: string;
  admireEntreprenurError: string;
  primaryExpectation:
    | undefined
    | "Learning"
    | "Finance"
    | "Product"
    | "Sales"
    | "Technology"
    | "other";
  primaryExpectationError: string;
  otherPrimaryExpectation: string;
  additionalEffort: boolean | undefined;
  additionalEffortError: string;
  attendAllWorkshops: boolean | undefined;
  attendAllWorkshopsError: string;
  payRequiredEnrolmentFee: boolean | undefined;
  payRequiredEnrolmentFeeError: string;
  teamName: string;
  teamNameError: string;
  domain: string;
  domainError: string;
  college: string;
  collegeError: string;
  mentorName: string;
  mentorNameError: string;
  mentorEmail: string;
  mentorEmailError: string;
  mentorContact: string;
  mentorContactError: string;
  leader: TeamMemberInApplication;
  loading: boolean;
  hasError: boolean;
  formStage: "TEAM_DATA" | "MEMBERS_DATA";
  showGuidelines: boolean;
}

interface TeamMemberInApplication {
  name: string;
  nameError: string;
  yearOfStudy: string;
  yearOfStudyError: string;
  email: string;
  emailError: string;
  contact: string;
  contactError: string;
  role: TeamRole;
}

/*interface Facultymentor {
  name: string;
  email: string;
  contact: string;
}*/

const initialMember: TeamMemberInApplication = {
  name: "",
  nameError: "",
  yearOfStudy: "",
  yearOfStudyError: "",
  email: "",
  emailError: "",
  contact: "",
  contactError: "",

  role: TeamRole.LEADER,
};

const initialState: IState = {
  isAgree: false,
  isAgreeError: "",
  projectName: "",
  projectNameError: "",
  problem: "",
  problemError: "",
  unique: "",
  uniqueError: "",
  stage: undefined,
  stageError: "",
  otherState: "",
  otherStateError: "",
  progress: "",
  progressError: "",
  pitch: null,
  pitchError: "",
  pitchLink: "",
  pitchLinkError: "",
  requiredInvensment: "",
  requiredInvensmentError: "",
  invesmentDone: "",
  invesmentDoneError: "",
  expectedTime: "",
  expectedTimeError: "",
  anyPatent: "",
  anyPatentError: "",
  whyEntreprenur: "",
  whyEntreprenurError: "",
  howLoongThinking: undefined,
  howLoongThinkingError: "",
  strenghts: "",
  strenghtsError: "",
  anyCourse: "",
  anyCourseError: "",
  howStrong: 1,
  howStrongError: "",
  admireEntreprenur: "",
  admireEntreprenurError: "",
  primaryExpectation: undefined,
  primaryExpectationError: "",
  otherPrimaryExpectation: "",
  additionalEffort: undefined,
  additionalEffortError: "",
  attendAllWorkshops: undefined,
  attendAllWorkshopsError: "",
  payRequiredEnrolmentFee: undefined,
  payRequiredEnrolmentFeeError: "",
  teamName: "",
  teamNameError: "",
  domain: "",
  domainError: "",
  college: "",
  collegeError: "",
  mentorName: "",
  mentorNameError: "",
  mentorEmail: "",
  mentorEmailError: "",
  mentorContact: "",
  mentorContactError: "",
  leader: initialMember,
  loading: false,
  hasError: false,
  formStage: "TEAM_DATA",
  showGuidelines: false,
};

const initialMembers: TeamMemberInApplication[] = [initialMember];

interface IProps {
  onComplete(application: Application, fileName: string): void;
}

const ApplicationFormIndia = (props: IProps) => {
  const [state, setState] = useState(initialState);
  const [members, setMembers] = useState(initialMembers);

  const inup: any = null;
  const [uploader, setUploader] = useState(inup);
  const [upFileName, setUpFileName] = useState("");

  useEffect(() => {
    setState(initialState);
  }, []);

  //   const applicationRef = useFirestore().collection("applications");

  const validateTeamData = (): boolean => {
    const isAgreeValidation = state.isAgree
      ? {
          message: "",
          isValid: true,
        }
      : {
          message:
            "Please click 'Yes' after reading the competition rules and guidelines to be able to submit the application",
          isValid: false,
        };

    const projectNameValidation = FormValidator.validateString(
      state.projectName,
      "Project/Product Name",
      3,
      100
    );

    const problemValidation = FormValidator.validateString(
      state.problem,
      "The answer",
      3,
      1500
    );
    const uniqueValidation = FormValidator.validateString(
      state.unique,
      "The answer",
      3,
      500
    );
    let stageValidation = FormValidator.validateString(
      state.stage,
      "Please select an answer"
    );
    if (!stageValidation.isValid)
      stageValidation.message = "Please select an answer.";
    if (state.stage === "other") {
      stageValidation = FormValidator.validateString(
        state.otherState,
        "Please select an answer"
      );
      if (!stageValidation.isValid)
        stageValidation.message = "Please select an answer.";
    }

    const progressValidation = FormValidator.validateString(
      state.progress,
      "The answer",
      3,
      1500
    );

    const fileValidation =
      state.pitch === null
        ? { message: "Pitch is required.", isValid: false }
        : state.pitch.type !== "application/pdf"
        ? { message: "Only pdf files are allowed.", isValid: false }
        : state.pitch.size > 105255200
        ? {
            message: "File size cannot be more than 100MB",
            isValid: false,
          }
        : { message: "", isValid: true };

    const requiredInvencementValidation = FormValidator.validateString(
      state.requiredInvensment,
      "The answer",
      3,
      500
    );
    const requiredInvencementDoneValidation = FormValidator.validateString(
      state.invesmentDone,
      "The answer",
      3,
      500
    );
    const anyPatentValidation = FormValidator.validateString(
      state.anyPatent,
      "The answer",
      500
    );
    const whyEntreprenurValidation = FormValidator.validateString(
      state.whyEntreprenur,
      "The answer",
      3,
      1500
    );
    const howLoongThinkingValidation = FormValidator.validateString(
      state.howLoongThinking,
      "Please select an answer."
    );

    if (!howLoongThinkingValidation.isValid)
      howLoongThinkingValidation.message = "Please select an answer.";

    const strenghtsValidation = FormValidator.validateString(
      state.strenghts,
      "The answer",
      3,
      500
    );
    const anyCourseValidation = FormValidator.validateString(
      state.anyCourse,
      "The answer",
      3,
      500
    );
    const admireEntreprenurValidation = FormValidator.validateString(
      state.admireEntreprenur,
      "The answer",
      3,
      500
    );
    let primaryExpectationValidation = FormValidator.validateString(
      state.primaryExpectation,
      "Please select an answer"
    );

    if (state.primaryExpectation === "other") {
      primaryExpectationValidation = FormValidator.validateString(
        state.otherPrimaryExpectation,
        "The answer"
      );
    }
    if (!primaryExpectationValidation.isValid)
      primaryExpectationValidation.message = "Please select an answer.";

    const additionalEffortValidation =
      state.additionalEffort !== undefined
        ? {
            message: "",
            isValid: true,
          }
        : {
            message: "Please select an answer.",
            isValid: false,
          };
    const attendAllWorkshopsValidation =
      state.attendAllWorkshops !== undefined
        ? {
            message: "",
            isValid: true,
          }
        : {
            message: "Please select an answer.",
            isValid: false,
          };
    const payRequiredEnrolmentFeeValidation =
      state.payRequiredEnrolmentFee !== undefined
        ? {
            message: "",
            isValid: true,
          }
        : {
            message: "Please select an answer.",
            isValid: false,
          };

    const howStrongValidation =
      state.howStrong > 0
        ? {
            message: "",
            isValid: true,
          }
        : {
            message: "Please select an answer.",
            isValid: false,
          };

    setState({
      ...state,
      isAgreeError: isAgreeValidation.message,
      projectNameError: projectNameValidation.message,
      problemError: problemValidation.message,
      uniqueError: uniqueValidation.message,
      progressError: progressValidation.message,
      pitchError: fileValidation.message,
      requiredInvensmentError: requiredInvencementValidation.message,
      invesmentDoneError: requiredInvencementDoneValidation.message,
      whyEntreprenurError: whyEntreprenurValidation.message,
      howLoongThinkingError: howLoongThinkingValidation.message,
      strenghtsError: strenghtsValidation.message,
      anyCourseError: anyCourseValidation.message,
      stageError: stageValidation.message,
      anyPatentError: anyPatentValidation.message,
      primaryExpectationError: primaryExpectationValidation.message,
      admireEntreprenurError: admireEntreprenurValidation.message,
      additionalEffortError: additionalEffortValidation.message,
      howStrongError: howStrongValidation.message,
      attendAllWorkshopsError: additionalEffortValidation.message,
      payRequiredEnrolmentFeeError: additionalEffortValidation.message,
    });

    return (
      isAgreeValidation.isValid &&
      projectNameValidation.isValid &&
      problemValidation.isValid &&
      uniqueValidation.isValid &&
      progressValidation.isValid &&
      fileValidation.isValid &&
      requiredInvencementValidation.isValid &&
      requiredInvencementDoneValidation.isValid &&
      whyEntreprenurValidation.isValid &&
      howLoongThinkingValidation.isValid &&
      strenghtsValidation.isValid &&
      stageValidation.isValid &&
      anyPatentValidation.isValid &&
      primaryExpectationValidation.isValid &&
      anyCourseValidation.isValid &&
      additionalEffortValidation.isValid &&
      attendAllWorkshopsValidation.isValid &&
      payRequiredEnrolmentFeeValidation.isValid &&
      admireEntreprenurValidation.isValid &&
      howStrongValidation.isValid
      // howStrongValidation.isValid
    );
  };

  const validateTeamLeaderData = (): boolean => {
    const contactValidation = FormValidator.validateString(
      state.leader.contact,
      "Contact number",
      3,
      100
    );
    const nameValidation = FormValidator.validateString(
      state.leader.name,
      "The name",
      3,
      100
    );
    const yearOfStudyValidation = FormValidator.validateString(
      state.leader.yearOfStudy,
      "Year/semester of study",
      3,
      100
    );

    const memberEmails = members.map((member) => member.email);

    const emailValidation = FormValidator.validateApplicationEmails(
      state.leader.email,
      memberEmails
    );

    setState((ps) => ({
      ...ps,
      leader: {
        ...ps.leader,
        contactError: contactValidation.message,
        nameError: nameValidation.message,
        emailError: emailValidation.message,
        yearOfStudyError: yearOfStudyValidation.message,
      },
    }));

    return (
      contactValidation.isValid &&
      nameValidation.isValid &&
      yearOfStudyValidation.isValid &&
      emailValidation.isValid
    );
  };

  const validateTeamADData = (): boolean => {
    const teamNameValidation = FormValidator.validateString(
      state.leader.name,
      "Team name",
      3,
      100
    );
    const domainValidation = FormValidator.validateString(
      state.leader.name,
      "Domain/Category",
      3,
      100
    );
    const collegeValidation = FormValidator.validateString(
      state.leader.name,
      "College/University name",
      3,
      100
    );
    const mentorNameValidation = FormValidator.validateString(
      state.leader.name,
      "Faculty Mentor Name",
      3,
      100
    );
    const mentorEmailValidation = FormValidator.validateEmail(
      state.mentorEmail
    );
    const mentorContactValidation = FormValidator.validateString(
      state.leader.name,
      "Faculty Mentor Contact No",
      3,
      100
    );

    setState((ps) => ({
      ...ps,
      teamNameError: teamNameValidation.message,
      domainError: domainValidation.message,
      collegeError: collegeValidation.message,
      mentorNameError: mentorNameValidation.message,
      mentorEmailError: mentorEmailValidation.message,
      mentorContactError: mentorContactValidation.message,
    }));

    return (
      teamNameValidation.isValid &&
      domainValidation.isValid &&
      collegeValidation.isValid &&
      mentorNameValidation.isValid &&
      mentorEmailValidation.isValid &&
      mentorContactValidation.isValid
    );
  };

  const validateTeamMembers = (): boolean => {
    return (
      members
        .map((member, index) => {
          const nameValidation = FormValidator.validateString(
            member.name,
            "The name",
            3,
            100
          );

          const memberEmails = members
            .filter((memb, i) => index !== i)
            .map((mem) => mem.email);
          memberEmails.push(state.leader.email);

          const emailValidation = FormValidator.validateApplicationEmails(
            member.email,
            memberEmails
          );

          const rllValidation = FormValidator.validateString(
            member.role.toString(),
            "Roll"
          );
          const contactValidation = FormValidator.validateString(
            member.contact,
            "Contact number",
            3,
            100
          );
          const yearOfStudyValidation = FormValidator.validateString(
            member.yearOfStudy,
            "Year/semester of study",
            3,
            100
          );

          members[index] = {
            ...member,
            contactError: contactValidation.message,
            nameError: nameValidation.message,
            emailError: emailValidation.message,
            yearOfStudyError: yearOfStudyValidation.message,
          };
          setMembers(Object.assign([], members));

          return (
            nameValidation.isValid &&
            emailValidation.isValid &&
            contactValidation.isValid &&
            yearOfStudyValidation.isValid &&
            rllValidation.isValid
          );
        })
        .filter((b) => !b).length === 0
    );
  };

  const applicationRef = useFunctions().httpsCallable("submitApplicationIndia");
  const storageRef = useStorage().ref();
  // const [uploadPrograss, setUploadProgress] = useState(0);

  const validateAllData = (): boolean => {
    const a = validateTeamData();
    const b = validateTeamLeaderData();
    const c = validateTeamMembers();
    const d = validateTeamADData();
    if (a && b && c && d) {
      return true;
    } else {
      setTimeout(() => {
        document
          .getElementsByClassName("invalid")
          .item(0)
          ?.parentElement?.scrollIntoView({
            behavior: "smooth",
          });
      }, 100);
      return false;
    }
  };

  const submitForm = () => {
    setState((ps) => ({ ...ps, loading: true }));
    const file: any = state.pitch;
    const uploadTask = storageRef
      .child(`proposals/${state.pitch?.name}`)
      .put(file);
    uploadTask.on(
      "state_changed",
      (snap) => {
        console.log(snap.bytesTransferred);
      },
      (err) => {
        // alert("proposalLink upload error");
        // setState(initialState);
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((url) => {
          // const industries = Object.assign([], state.industry);
          // if (other.checked) industries.push(other.value);

          let teamMembersWithLeader: TeamMember[] = members.map((tm) => ({
            fullName: tm.name,
            yearOfStudy: tm.yearOfStudy,
            email: tm.email,
            contact: tm.contact,
            role: TeamRole.MEMBER,
            country: Country.INDIA,
          }));

          teamMembersWithLeader.push({
            fullName: state.leader.name,
            yearOfStudy: state.leader.yearOfStudy,
            email: state.leader.email,
            contact: state.leader.contact,
            role: TeamRole.LEADER,
            country: Country.INDIA,
          });

          const applicationData: Application = {
            projectName: state.projectName,
            problem: state.problem,
            unique: state.unique,
            stage:
              state.stage === "other"
                ? state.otherState
                : (state.stage as string),
            progress: state.progress,
            pitch: url,
            requiredInvensment: state.requiredInvensment,
            invesmentDone: state.invesmentDone,
            expectedTime: state.expectedTime,
            anyPatent: state.anyPatent,
            whyEntreprenur: state.whyEntreprenur,
            howLoongThinking: state.howLoongThinking as string,
            strenghts: state.strenghts,
            anyCourse: state.anyCourse,
            howStrong: state.howStrong,
            admireEntreprenur: state.admireEntreprenur,
            primaryExpectation:
              state.primaryExpectation === "other"
                ? state.otherPrimaryExpectation
                : (state.primaryExpectation as string),
            additionalEffort: state.additionalEffort as boolean,
            attendAllWorkshops: state.attendAllWorkshops as boolean,
            payRequiredEnrolmentFee: state.payRequiredEnrolmentFee as boolean,
            teamName: state.teamName,
            domain: state.domain,
            college: state.college,
            mentorName: state.mentorName,
            mentorEmail: state.mentorEmail,
            mentorContact: state.mentorContact,
            members: teamMembersWithLeader,
            country: Country.INDIA,
          };
          applicationRef(applicationData)
            .then((data) => {
              // initialState.industry = [];
              // setState({ ...initialState });
              initialMembers[0] = initialMember;
              setMembers(Object.assign([], initialMembers));
              const fileName = `${upFileName}`;
              setUpFileName("");
              props.onComplete(applicationData, fileName);
            })
            .catch((err) => {
              console.log("application submission failed - ", err);
              storageRef
                .child(`proposals/${state.pitch?.name}`)
                .delete()
                .then(() => {
                  //doto - handle this
                  console.log("File deleted successfully");
                })
                .catch(() => {
                  //doto - handle this
                  console.log("Uh-oh, an error occurred!");
                })
                .finally(() => {
                  setState({ ...state, loading: false, hasError: true });
                  setShow(false);
                });
            })
            .finally(() => {});
        });
      }
    );
  };

  const teamData = () => {
    return (
      <div>
        <FormGroup>
          <label className="font-weight-bold form-label">
            I have read, understood, and agree to the{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://in.ieee.org/guidelines-srilanka"
            >
              competition rules and guidelines
            </a>
          </label>
          <fieldset id="group5">
            <div className="form-check">
              <input
                type="radio"
                checked={state.isAgree}
                name="group5"
                className="form-check-input"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    isAgree: e.target.checked,
                    isAgreeError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) => setState({ ...state, isAgree: true })}
              >
                Yes
              </label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                checked={!state.isAgree}
                className="form-check-input"
                name="group5"
                onChange={(e: any) =>
                  setState({ ...state, isAgree: !e.target.checked })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) => setState({ ...state, isAgree: false })}
              >
                No
              </label>
            </div>
          </fieldset>
          <label className="error-message">{state.isAgreeError}</label>
          <input
            className={
              state.isAgreeError.length < 1 ? "d-none" : "d-none invalid"
            }
          />
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Project/Product Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.projectNameError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.projectName}
            onChange={(e) => {
              setState({
                ...state,
                projectName: e.target.value,
                projectNameError: "",
              });
            }}
          />
          <label className="error-message">{state.projectNameError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Problem Statement (or what are you trying to achieve?)
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.problemError.length < 1 ? "app-input" : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.problem}
            onChange={(e) => {
              setState({
                ...state,
                problem: e.target.value,
                problemError: "",
              });
            }}
          />
          <label className="error-message">{state.problemError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            What is unique about your Project/Product
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.uniqueError.length < 1 ? "app-input" : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.unique}
            onChange={(e) => {
              setState({
                ...state,
                unique: e.target.value,
                uniqueError: "",
              });
            }}
          />
          <label className="error-message">{state.uniqueError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            What stage you are at
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.stageError.length < 1 ? "d-none" : "d-none invalid"
            }
          />

          <AppFormCheck
            type="radio"
            label="Concept"
            checked={state.stage === "Concept"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({ ...ps, stage: "Concept", stageError: "" }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Defining the product"
            checked={state.stage === "Defining the product"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  stage: "Defining the product",
                  stageError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Building prototype"
            checked={state.stage === "Building prototype"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  stage: "Building prototype",
                  stageError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Have beta users using the product"
            checked={state.stage === "Have beta users using the product"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  stage: "Have beta users using the product",
                  stageError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Commercial"
            checked={state.stage === "Commercial"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  stage: "Commercial",
                  stageError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Looking to scale up"
            checked={state.stage === "Looking to scale up"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  stage: "Looking to scale up",
                  stageError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />

          <AppFormCheck
            type="radio"
            label="Other"
            checked={state.stage === "other"}
            onChange={(e: any) => {
              if (e) {
                setState((ps) => ({ ...ps, stage: "other", stageError: "" }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          {state.stage === "other" && (
            <>
              <input
                className={
                  state.stageError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={state.otherState}
                onChange={(e) => {
                  setState((ps) => ({
                    ...ps,
                    otherState: e.target.value,
                    stageError: "",
                  }));
                }}
              />
            </>
          )}
          <label className="error-message">{state.stageError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            What is the progress so far?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <textarea
            className={
              state.progressError.length < 1 ? "app-input" : "app-input invalid"
            }
            value={state.progress}
            placeholder="Your Answer"
            onChange={(e) => {
              setState({
                ...state,
                progress: e.target.value,
                progressError: "",
              });
            }}
          />
          <label className="error-message">{state.progressError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Upload a pitch document (
            <a
              href="https://ieeetemsblr.org/yeep-idea-template/"
              target="_blank"
              rel="noopener noreferrer"
            >
              See for suggested structure
            </a>
            )
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>

          <br />
          <input
            className="d-none"
            type="file"
            accept=".pdf"
            ref={(ref) => setUploader(ref)}
            onChange={(e) => {
              const file = e.target.files && e.target.files[0];
              console.log(file?.name);
              if (file !== null) {
                setUpFileName(file?.name);
                const blob = file?.slice(0, file.size, file?.type);
                const newFile = new File(
                  [blob],
                  `${randomString.generate()}.${file?.name.split(".").pop()}`,
                  { type: file?.type }
                );
                if (file?.type !== "application/pdf") {
                  setState({
                    ...state,
                    pitch: newFile,
                    pitchError: "Only pdf files are allowed.",
                  });
                } else if (file?.size > 105255200) {
                  setState({
                    ...state,
                    pitch: newFile,
                    pitchError: "File size cannot be more than 100MB",
                  });
                } else {
                  setState({ ...state, pitch: newFile, pitchError: "" });
                }
              }
              e.target.value = "";
            }}
          />
          {upFileName.length > 0 ? (
            <div className="uploaded-file animated fadeIn">
              <span>
                <AiOutlineFilePdf />
              </span>
              <span className="mx-2">{upFileName}</span>
              <span className="remove-file">
                <MdClose
                  onClick={() => {
                    setUpFileName("");
                    setState({ ...state, pitch: null, pitchError: "" });
                  }}
                />
              </span>
            </div>
          ) : (
            <button className="app-button" onClick={() => uploader.click()}>
              <span className="mr-2">
                <MdAdd style={{ transform: "scale(1.5) translateY(-2px)" }} />
              </span>
              Attach File
            </button>
          )}
          <br />
          <label className="mt-2" style={{ fontSize: "12px" }}>
            Only pdf files allow to upload for the pitch deck
          </label>
          <br />
          <label className="error-message">{state.pitchError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            How much investment is required to create a first prototype that
            meets your objectives?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.requiredInvensmentError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.requiredInvensment}
            onChange={(e) => {
              setState({
                ...state,
                requiredInvensment: e.target.value,
                requiredInvensmentError: "",
              });
            }}
          />
          <label className="error-message">
            {state.requiredInvensmentError}
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            How much investment is done by your team so far, if any?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.invesmentDoneError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.invesmentDone}
            onChange={(e) => {
              setState({
                ...state,
                invesmentDone: e.target.value,
                invesmentDoneError: "",
              });
            }}
          />
          <label className="error-message">{state.invesmentDoneError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Expected time needed to implement a prototype
          </label>
          <input
            className="app-input"
            placeholder="Your answer"
            value={state.expectedTime}
            onChange={(e) => {
              setState({
                ...state,
                expectedTime: e.target.value,
              });
            }}
          />
        </FormGroup>
        <FormGroup className="mt-4">
          <label className="font-weight-bold form-label">
            Any Patent applied or will be applied
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.anyPatentError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.anyPatent}
            onChange={(e) => {
              setState({
                ...state,
                anyPatent: e.target.value,
                anyPatentError: "",
              });
            }}
          />
          <label className="error-message">{state.anyPatentError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Why do you want to be an entrepreneur? Please write not more than
            200 words, for each team member.
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <textarea
            className={
              state.whyEntreprenurError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.whyEntreprenur}
            onChange={(e) => {
              setState({
                ...state,
                whyEntreprenur: e.target.value,
                whyEntreprenurError: "",
              });
            }}
          />
          <label className="error-message">{state.whyEntreprenurError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            How long have you been thinking of the idea you are proposing?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>

          <AppFormCheck
            type="radio"
            label="Since this mailer was received"
            checked={
              state.howLoongThinking === "Since this mailer was received"
            }
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  howLoongThinking: "Since this mailer was received",
                  howLoongThinkingError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="More than a month"
            checked={state.howLoongThinking === "More than a month"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  howLoongThinking: "More than a month",
                  howLoongThinkingError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="1 to 3 months"
            checked={state.howLoongThinking === "1 to 3 months"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  howLoongThinking: "1 to 3 months",
                  howLoongThinkingError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="3 - 6 months"
            checked={state.howLoongThinking === "3 - 6 months"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  howLoongThinking: "3 - 6 months",
                  howLoongThinkingError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label=">6 months"
            checked={state.howLoongThinking === ">6 months"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  howLoongThinking: ">6 months",
                  howLoongThinkingError: "",
                }));
              } else {
                setState((ps) => ({ ...ps, stage: undefined }));
              }
            }}
          />
          <label className="error-message">{state.howLoongThinkingError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            What strengths does your team have that will help you in this
            journey?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            type="text"
            className={
              state.strenghtsError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.strenghts}
            onChange={(e) => {
              setState({
                ...state,
                strenghts: e.target.value,
                strenghtsError: "",
              });
            }}
          />
          <label className="error-message">{state.strenghtsError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Any course on entrepreneurship, business management that any team
            member has already taken?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            type="text"
            className={
              state.anyCourseError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.anyCourse}
            onChange={(e) => {
              setState({
                ...state,
                anyCourse: e.target.value,
                anyCourseError: "",
              });
            }}
          />
          <label className="error-message">{state.anyCourseError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            How strong is your belief in your idea?
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            <label>Trying Luck</label>
            <label>Strong</label>
          </div>
          <Slider
            value={state.howStrong}
            min={1}
            max={10}
            step={1}
            labels={{
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
              6: "6",
              7: "7",
              8: "8",
              9: "9",
              10: "10",
            }}
            onChange={(value) =>
              setState({ ...state, howStrong: value, howStrongError: "" })
            }
          />
          <label className="error-message mt-3">{state.howStrongError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Which entrepreneur do you admire the most? Why
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            type="text"
            className={
              state.admireEntreprenurError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            placeholder="Your answer"
            value={state.admireEntreprenur}
            onChange={(e) => {
              setState({
                ...state,
                admireEntreprenur: e.target.value,
                admireEntreprenurError: "",
              });
            }}
          />
          <label className="error-message">
            {state.admireEntreprenurError}
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            What is your primary expectation of the program
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.uniqueError.length < 1 ? "d-none" : "d-none invalid"
            }
          />

          <AppFormCheck
            type="radio"
            label="Learning"
            checked={state.primaryExpectation === "Learning"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  primaryExpectation: "Learning",
                  primaryExpectationError: "",
                }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Finance"
            checked={state.primaryExpectation === "Finance"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  primaryExpectation: "Finance",
                  primaryExpectationError: "",
                }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Product"
            checked={state.primaryExpectation === "Product"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  primaryExpectation: "Product",
                  primaryExpectationError: "",
                }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Sales"
            checked={state.primaryExpectation === "Sales"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  primaryExpectation: "Sales",
                  primaryExpectationError: "",
                }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Technology"
            checked={state.primaryExpectation === "Technology"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  primaryExpectation: "Technology",
                  primaryExpectationError: "",
                }));
              }
            }}
          />
          <AppFormCheck
            type="radio"
            label="Other"
            checked={state.primaryExpectation === "other"}
            onChange={(e: boolean) => {
              if (e) {
                setState((ps) => ({
                  ...ps,
                  primaryExpectation: "other",
                  primaryExpectationError: "",
                }));
              }
            }}
          />
          {state.primaryExpectation === "other" && (
            <>
              <input
                className={
                  state.primaryExpectationError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={state.otherPrimaryExpectation}
                onChange={(e) => {
                  setState((ps) => ({
                    ...ps,
                    otherPrimaryExpectation: e.target.value,
                    primaryExpectationError: "",
                  }));
                }}
              />
            </>
          )}

          <label className="error-message">
            {state.primaryExpectationError}
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            I understand that this will be an additional effort beyond my
            regular academics
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <fieldset id="group6">
            <div className="form-check">
              <input
                type="radio"
                checked={state.additionalEffort === true}
                name="group6"
                className="form-check-input"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    additionalEffort: true,
                    additionalEffortError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) =>
                  setState({
                    ...state,
                    additionalEffort: true,
                    additionalEffortError: "",
                  })
                }
              >
                Yes
              </label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                checked={state.additionalEffort === false}
                className="form-check-input"
                name="group6"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    additionalEffort: false,
                    additionalEffortError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) =>
                  setState({
                    ...state,
                    additionalEffort: false,
                    additionalEffortError: "",
                  })
                }
              >
                No
              </label>
            </div>
          </fieldset>
          <label className="error-message">{state.additionalEffortError}</label>
          <input
            className={
              state.additionalEffortError.length < 1
                ? "d-none"
                : "d-none invalid"
            }
          />
        </FormGroup>{" "}
        <FormGroup>
          <label className="font-weight-bold form-label">
            I commit to completing the full program and attend all
            workshops/activities/courses
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <fieldset id="group7">
            <div className="form-check">
              <input
                type="radio"
                checked={state.attendAllWorkshops === true}
                name="group7"
                className="form-check-input"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    attendAllWorkshops: true,
                    attendAllWorkshopsError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) =>
                  setState({
                    ...state,
                    attendAllWorkshops: true,
                    attendAllWorkshopsError: "",
                  })
                }
              >
                Yes
              </label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                checked={state.attendAllWorkshops === false}
                className="form-check-input"
                name="group7"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    attendAllWorkshops: false,
                    attendAllWorkshopsError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) =>
                  setState({
                    ...state,
                    attendAllWorkshops: false,
                    attendAllWorkshopsError: "",
                  })
                }
              >
                No
              </label>
            </div>
          </fieldset>
          <label className="error-message">
            {state.attendAllWorkshopsError}
          </label>
          <input
            className={
              state.attendAllWorkshopsError.length < 1
                ? "d-none"
                : "d-none invalid"
            }
          />
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            I confirm that I will pay the required enrolment fee if selected (Rs
            1000 / Rs 750 if a IEEE member in team/ Rs 500 if a TEMS member in
            team)
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <fieldset id="group8">
            <div className="form-check">
              <input
                type="radio"
                checked={state.payRequiredEnrolmentFee === true}
                name="group8"
                className="form-check-input"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    payRequiredEnrolmentFee: e.target.checked,
                    payRequiredEnrolmentFeeError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) =>
                  setState({
                    ...state,
                    payRequiredEnrolmentFee: true,
                    payRequiredEnrolmentFeeError: "",
                  })
                }
              >
                Yes
              </label>
            </div>
            <div className="form-check">
              <input
                type="radio"
                checked={state.payRequiredEnrolmentFee === false}
                className="form-check-input"
                name="group8s"
                onChange={(e: any) =>
                  setState({
                    ...state,
                    payRequiredEnrolmentFee: false,
                    payRequiredEnrolmentFeeError: "",
                  })
                }
              />
              <label
                className="form-check-label"
                onClick={(e: any) =>
                  setState({
                    ...state,
                    payRequiredEnrolmentFee: false,
                    payRequiredEnrolmentFeeError: "",
                  })
                }
              >
                No
              </label>
            </div>
          </fieldset>
          <label className="error-message">
            {state.payRequiredEnrolmentFeeError}
          </label>
          <input
            className={
              state.payRequiredEnrolmentFeeError.length < 1
                ? "d-none"
                : "d-none invalid"
            }
          />
        </FormGroup>
      </div>
    );
  };

  const teamMembers = () => {
    return (
      <div>
        {members.map((member, index) => (
          <div className="animated fadeIn" key={index}>
            <FormGroup>
              <label
                className="font-weight-bold form-label mr-2"
                style={{ fontSize: "large" }}
              >
                Team member {index + 1}
              </label>
              {index > 0 && (
                <>
                  |
                  <label
                    className="link-label ml-2"
                    onClick={() => {
                      members.splice(index, 1);
                      setMembers(Object.assign([], members));
                    }}
                  >
                    remove
                  </label>
                </>
              )}
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                Name
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  member.nameError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={member.name}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    name: e.target.value,
                    nameError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">{member.nameError}</label>
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                Year/semester of study
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  member.yearOfStudyError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={member.yearOfStudy}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    yearOfStudy: e.target.value,
                    yearOfStudyError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">{member.yearOfStudyError}</label>
            </FormGroup>
            <FormGroup>
              <label className="font-weight-bold form-label">
                Email
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  member.emailError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                value={member.email}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    email: e.target.value,
                    emailError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">{member.emailError}</label>
            </FormGroup>

            <FormGroup>
              <label className="font-weight-bold form-label">
                Contact Number
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <input
                className={
                  member.contactError.length < 1
                    ? "app-input"
                    : "app-input invalid"
                }
                // placeholder="+94771231234 / 0771231234"
                value={member.contact}
                onChange={(e) => {
                  members[index] = {
                    ...member,
                    contact: e.target.value,
                    contactError: "",
                  };
                  setMembers(Object.assign([], members));
                }}
              />
              <label className="error-message">{member.contactError}</label>
            </FormGroup>
            <FormGroup className="d-none">
              <label className="font-weight-bold">
                Role in the team
                <span className="ml-1" style={{ color: "red" }}>
                  *
                </span>
              </label>
              <fieldset id="group2">
                <Form.Check
                  type="radio"
                  label="Team member"
                  value="Team member"
                  name="group2"
                  checked={member.role === TeamRole.MEMBER}
                  onChange={(e: any) => {
                    members[index] = { ...member, role: TeamRole.MEMBER };
                    setMembers(Object.assign([], members));
                  }}
                />
                <Form.Check
                  type="radio"
                  label="Supervisor"
                  value="Supervisor"
                  name="group2"
                  checked={member.role === TeamRole.SUPERVISOR}
                  onChange={(e: any) => {
                    members[index] = { ...member, role: TeamRole.SUPERVISOR };
                    setMembers(Object.assign([], members));
                  }}
                />
              </fieldset>
              {/* <label className="error-message">{member.roleError}</label> */}
            </FormGroup>
          </div>
        ))}
      </div>
    );
  };

  const teamMembersData = () => {
    return (
      <div>
        <>{teamMembers()}</>
        {members.length < 4 && (
          <FormGroup className="text-right">
            <button
              className="app-button"
              onClick={(e) => {
                members.push(initialMember);
                setMembers(Object.assign([], members));
              }}
            >
              <span className="mr-2">
                <MdAdd style={{ transform: "scale(1.5) translateY(-2px)" }} />
              </span>
              Add Member
            </button>
          </FormGroup>
        )}
      </div>
    );
  };

  const teamADData = () => {
    return (
      <div>
        <FormGroup>
          <label
            className="font-weight-bold form-label"
            style={{ fontSize: "larger" }}
          >
            Team Info
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Team Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.teamNameError.length < 1 ? "app-input" : "app-input invalid"
            }
            value={state.teamName}
            onChange={(e) => {
              setState({
                ...state,
                teamName: e.target.value,
                teamNameError: "",
              });
            }}
          />
          <label className="error-message">{state.teamNameError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Domain/Category
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.domainError.length < 1 ? "app-input" : "app-input invalid"
            }
            value={state.domain}
            onChange={(e) => {
              setState({
                ...state,
                domain: e.target.value,
                domainError: "",
              });
            }}
          />
          <label className="error-message">{state.domainError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            College/University Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.collegeError.length < 1 ? "app-input" : "app-input invalid"
            }
            value={state.college}
            onChange={(e) => {
              setState({
                ...state,
                college: e.target.value,
                collegeError: "",
              });
            }}
          />
          <label className="error-message">{state.collegeError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Faculty Mentor Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.mentorNameError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.mentorName}
            onChange={(e) => {
              setState({
                ...state,
                mentorName: e.target.value,
                mentorNameError: "",
              });
            }}
          />
          <label className="error-message">{state.mentorNameError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Faculty Mentor Email Id
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.mentorEmailError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.mentorEmail}
            onChange={(e) => {
              setState({
                ...state,
                mentorEmail: e.target.value,
                mentorEmailError: "",
              });
            }}
          />
          <label className="error-message">{state.mentorEmailError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Faculty Mentor Contact No
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.mentorContactError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.mentorContact}
            onChange={(e) => {
              setState({
                ...state,
                mentorContact: e.target.value,
                mentorContactError: "",
              });
            }}
          />
          <label className="error-message">{state.mentorContactError}</label>
        </FormGroup>
      </div>
    );
  };

  const leaderForm = () => {
    return (
      <div>
        <FormGroup>
          <label
            className="font-weight-bold form-label"
            style={{ fontSize: "larger" }}
          >
            Personal Info
          </label>
        </FormGroup>
        <FormGroup>
          <label
            className="font-weight-bold form-label"
            style={{ fontSize: "large" }}
          >
            Team Leader Details
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Name
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.leader.nameError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.leader.name}
            onChange={(e) => {
              setState({
                ...state,
                leader: {
                  ...state.leader,
                  name: e.target.value,
                  nameError: "",
                },
              });
            }}
          />
          <label className="error-message">{state.leader.nameError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Year/semester of study
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.leader.yearOfStudyError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.leader.yearOfStudy}
            onChange={(e) => {
              setState({
                ...state,
                leader: {
                  ...state.leader,
                  yearOfStudy: e.target.value,
                  yearOfStudyError: "",
                },
              });
            }}
          />
          <label className="error-message">
            {state.leader.yearOfStudyError}
          </label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Email
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.leader.emailError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            value={state.leader.email}
            onChange={(e) => {
              setState({
                ...state,
                leader: {
                  ...state.leader,
                  email: e.target.value,
                  emailError: "",
                },
              });
            }}
          />
          <label className="error-message">{state.leader.emailError}</label>
        </FormGroup>
        <FormGroup>
          <label className="font-weight-bold form-label">
            Contact Number
            <span className="ml-1" style={{ color: "red" }}>
              *
            </span>
          </label>
          <input
            className={
              state.leader.contactError.length < 1
                ? "app-input"
                : "app-input invalid"
            }
            // placeholder="+94771231234 / 0771231234"
            value={state.leader.contact}
            onChange={(e) => {
              setState({
                ...state,
                leader: {
                  ...state.leader,
                  contact: e.target.value,
                  contactError: "",
                },
              });
            }}
          />
          <label className="error-message">{state.leader.contactError}</label>
        </FormGroup>
      </div>
    );
  };

  const membersData = () => {
    return (
      <>
        {teamADData()}
        {leaderForm()}
        {teamMembersData()}
      </>
    );
  };

  const [show, setShow] = useState(false);

  return (
    <Container fluid>
      <Row className="p-md-5">
        <Col xs={12}>
          <form
            onSubmit={(e: any) => {
              e.preventDefault();
            }}
          >
            {state.formStage === "TEAM_DATA" ? teamData() : membersData()}{" "}
            {state.hasError && (
              <FormGroup
                style={{ marginTop: "40px" }}
                className="d-flex justify-content-end"
              >
                <div style={{ width: "300px" }}>
                  <Alert
                    show={state.hasError}
                    onClose={() => setState({ ...state, hasError: false })}
                  >
                    Application submission failed
                  </Alert>
                </div>
              </FormGroup>
            )}
            <FormGroup className="text-right">
              {state.formStage === "MEMBERS_DATA" && !state.loading && (
                <button
                  className="mr-1 app-button"
                  onClick={() => {
                    setState({ ...state, formStage: "TEAM_DATA" });
                  }}
                >
                  <span className="mr-2">
                    <MdNavigateBefore
                      style={{ transform: "scale(2) translateY(-1px)" }}
                    />
                  </span>
                  Back
                </button>
              )}
              {state.loading ? (
                <button className="app-button" disabled>
                  {state.formStage === "TEAM_DATA" ? "Next" : "Submit"}
                </button>
              ) : (
                <button
                  className="app-button"
                  onClick={(e) => {
                    if (state.formStage === "TEAM_DATA") {
                      if (validateTeamData()) {
                        setState((ps) => ({
                          ...ps,
                          formStage: "MEMBERS_DATA",
                        }));
                      } else {
                        setTimeout(() => {
                          document
                            .getElementsByClassName("invalid")
                            .item(0)
                            ?.parentElement?.scrollIntoView({
                              behavior: "smooth",
                            });
                        }, 100);
                      }
                    } else {
                      if (validateAllData()) setShow(true);
                    }
                  }}
                >
                  {state.formStage === "TEAM_DATA" ? (
                    <>
                      Next
                      <span className="ml-2">
                        <MdNavigateNext
                          style={{ transform: "scale(2) translateY(-1px)" }}
                        />
                      </span>
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              )}
            </FormGroup>
          </form>
        </Col>
      </Row>
      <Guidelines
        country={Country.SRI_LANKA}
        show={state.showGuidelines}
        onHide={() => setState({ ...state, showGuidelines: false })}
      />
      <Modal centered show={show} onHide={() => {}}>
        <Modal.Body style={{ padding: "40px", paddingBottom: "10px" }}>
          <FormGroup>
            <h5>Are you sure you want to submit the application?</h5>
            <p className="text-justify">
              Once you submit the application, you will not be able to make any
              more changes.
            </p>
          </FormGroup>
          {state.loading && (
            <FormGroup className="mt-2" style={{ marginBottom: "30px" }}>
              <BarLoader
                height={4}
                width={"100%"}
                color={"#00629b"}
                loading={state.loading}
              />
            </FormGroup>
          )}

          <FormGroup className="text-right">
            {!state.loading && (
              <>
                <button
                  className="app-button mr-2"
                  onClick={() => {
                    setShow(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="app-button"
                  onClick={() => {
                    if (validateAllData()) submitForm();
                  }}
                >
                  Submit
                </button>
              </>
            )}
          </FormGroup>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ApplicationFormIndia;
